import { LoadingIcon as Loading } from "@packages/ds";
import styled from "styled-components";

export const Description = styled.p`
  all: unset;
  color: var(--label-slate-color, var(--slate));
  font-size: 14px;
  line-height: 24px;
`;

export const Container = styled.div`
  max-width: 732px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AddressDisclaimer = styled.p`
  all: unset;
  color: var(--label-color-primary-600-color, var(--color-primary-600));
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
`;

export const PaymentMethodCard = styled.div`
  padding: 12px;
  border-radius: 5px;
  border: 1px solid var(--section-stone-border-color, var(--stone));
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PaymentMethodHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const PaymentMethodHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: var(--label-slate-color, var(--slate));
  line-height: 20px;
`;

export const PaymentMethodNumber = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: var(--label-granite-color, var(--granite));
  line-height: 20px;
`;

export const LoadingIcon = styled(Loading)`
  margin: 10px;
`;
